<div *ngIf="loading$ | async" class="fixed inset-0 flex flex-col gap-2 justify-center items-center bg-white z-50 overflow-hidden">
  <img src="/assets/images/tamiin-green-icon.svg" alt="Logo" class="w-14 animate-fade-in-out logo" />
  <!-- <div class="font-bold text-[30px] text-primary-main-color">Tamiin</div> -->
  <div class="font-bold text-[30px] text-tamiin-main-green">Tamiin</div>
</div>
